<template>
  <div v-if="deliveryCountries" class="delivery-country-modal">
    <ModalComponentHeader v-if="messages">
      {{ messages?.title }}
    </ModalComponentHeader>
    <ModalComponentBody>
      <p v-if="messages" class="delivery-country-modal-text">
        {{ messages?.availableCountriesTitle }}
      </p>
      <div class="delivery-countries">
        <button
          v-for="country in deliveryCountries?.items"
          :key="country.ID"
          type="button"
          class="delivery-countries-item"
          @click="handlerChangeCountry(country)"
        >
          {{ country.UF_NAME }}
        </button>
      </div>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';

import { useStore } from '@/store';
import { computed } from 'vue';
import { IDeliveryCountry } from '@store/interfaces/results/IDeliveryCountries/IDeliveryCountries';

const { state } = useStore();
const deliveryCountries = computed(() => state.results?.deliveryCountries);
const messages = computed(() => state.results?.deliveryCountries?.messages);
const setDeliveryCountry = computed(
  () => state.results?.deliveryCountries?.routes?.setDeliveryCountry
);

const handlerChangeCountry = async (country: IDeliveryCountry) => {
  try {
    if (setDeliveryCountry.value) {
      // console.log(country);
      const { path, action } = setDeliveryCountry.value;
      const params = {
        action,
        countryId: country.ID,
        countryCode: country.UF_COUNTRY_ISO_CODE,
      };
      const response = await axios.post(path, params);

      window.location.href = country?.UF_LINK;
    }
  } catch (err) {
    console.error(err);
  }
};
</script>

<style lang="scss" scoped>
.delivery-country-modal {
}
.delivery-country-modal-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  margin-bottom: 24px;
}
.delivery-countries {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 16px;
  @include point-md {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.delivery-countries-item {
  font-size: 14px;
  font-weight: 600;
  line-height: 125%; /* 17.5px */
  text-transform: uppercase;
  cursor: pointer;
  color: #885e46;
  background-color: transparent;
  text-align: left;
}
</style>
